import { CreditValue } from './PeerSelect.types';

// Utility function to create write-in options
const createWriteInOption = (search: string): CreditValue => ({
  value: search,
  label: `${search} - write-in`,
  type: 'credit_write_in',
});

export { createWriteInOption };
